import { VarianceRequest } from "../model";

export class VariancePostCommand{
    message:VarianceRequest;

    constructor(varianceView:VarianceRequest){
        this.message = varianceView;
    }
}